import { Plus } from "lucide-react";

export const B2BPricelist = ({ pricelist, onAdd }) => (
  <div className="overflow-x-auto rounded-2xl border border-[#E7E0D8] bg-white">
    <table className="w-full text-sm" data-testid="b2b-pricelist-table">
      <thead>
        <tr className="border-b border-[#E7E0D8] text-left font-mono-accent text-[10px] uppercase tracking-[0.15em] text-[#78716C]">
          <th className="p-4">Prodotto</th><th className="p-4">Categoria</th><th className="p-4">Peso</th>
          <th className="p-4 text-right">Pubblico</th><th className="p-4 text-right">Rivenditore</th><th className="p-4"></th>
        </tr>
      </thead>
      <tbody>
        {pricelist.items.map((p) => (
          <tr key={p.slug} className="border-b border-[#E7E0D8] last:border-0">
            <td className="p-4">
              <div className="flex items-center gap-3">
                <img src={p.image} alt="" className="w-10 h-10 rounded-lg object-cover" />
                <span className="font-medium">{p.name}</span>
              </div>
            </td>
            <td className="p-4 text-[#78716C]">{p.category}</td>
            <td className="p-4 text-[#78716C]">{p.weight || "—"}</td>
            <td className="p-4 text-right font-mono-accent line-through text-[#B4ADA3]">{p.price_retail.toFixed(2).replace(".", ",")} €</td>
            <td className="p-4 text-right font-mono-accent font-bold text-[#2E8A57]">{p.price_reseller.toFixed(2).replace(".", ",")} €</td>
            <td className="p-4">
              <button data-testid={`b2b-add-${p.slug}`} onClick={() => onAdd(p)} className="btn-tuscan w-8 h-8 rounded-full flex items-center justify-center" aria-label="Aggiungi al carrello">
                <Plus className="w-4 h-4" />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
